import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Card } from 'react-bootstrap';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const PostDetail = () => {
  const { postId } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const postRef = doc(db, 'posts', postId);
        const postDoc = await getDoc(postRef);
        if (postDoc.exists) {
          setPost({ id: postDoc.id, ...postDoc.data() });
        } else {
          console.error("No such document!");
        }
      } catch (err) {
        console.error("Error fetching post: ", err);
      }
    };
    fetchPost();
  }, [postId]);

  return (
    <Container className="mt-5 blog-post">
      {post ? (
        <>
          <h1 className="post-title">{post.title}</h1>
          <Card className="post-card">
            <Card.Body className='post'>
              <Card.Text className="custom-card-text" dangerouslySetInnerHTML={{ __html: post.content }} />
            </Card.Body>
          </Card>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </Container>
  );
};

export default PostDetail;
